import React from 'react';
import { developerInfo, skills } from '../mock';
import { Code2, Shield, Server, Terminal as TerminalIcon } from 'lucide-react';

const About = () => {
  const skillCategories = {
    backend: ['Laravel', 'Node.js', 'Elastic', 'PostgreSQL', 'MongoDB', 'Redis'],
    security: ['Vulnerability Assessment', 'OWASP Top 10', 'Burp Suite', 'Metasploit', 'Nmap', 'Wireshark'],
    devops: ['Docker', 'Kubernetes', 'Linux', 'Network Security'],
    other: skills.filter(s => 
      !['Laravel', 'Node.js', 'Elastic', 'PostgreSQL', 'MongoDB', 'Redis',
        'Vulnerability Assessment', 'OWASP Top 10', 'Burp Suite', 'Metasploit', 'Nmap', 'Wireshark',
        'Docker', 'Kubernetes', 'Linux', 'Network Security'].includes(s)
    )
  };

  return (
    <div className="page-container about-page">
      <div className="page-header">
        <h1 className="page-title">
          <span className="text-amber">[</span>
          ABOUT_ME
          <span className="text-amber">]</span>
        </h1>
        <div className="ascii-line">
          {'━'.repeat(60)}
        </div>
      </div>

      <div className="about-content">
        <div className="about-intro">
          <pre className="ascii-art">
{`
   _____                       _   _                 
  / ____|                     | | (_)                
 | (___   ___  ___ _   _ _ __ | |_ _ _ __ ___   ___  
  \___ \ / _ \/ __| | | | '__|| __| | '__/ _ \ / _ \ 
  ____) |  __/ (__| |_| | |   | |_| | | |  __/|  __/ 
 |_____/ \___|\___\\__,_|_|    \__|_|_|  \___| \___| 
                                                      
`}
          </pre>
          
          <div className="bio-section">
            <p className="bio-text">
              <span className="text-cyan">&gt;&gt;</span> {developerInfo.bio}
            </p>
            <p className="bio-text">
              <span className="text-cyan">&gt;&gt;</span> Based in {developerInfo.location}, I work as an independent developer 
              specializing in creating robust backend systems with security at the forefront.
            </p>
            <p className="bio-text">
              <span className="text-cyan">&gt;&gt;</span> My approach combines defensive programming practices with offensive 
              security mindset to build applications that are both functional and resilient against attacks.
            </p>
          </div>
        </div>

        <div className="skills-section">
          <h2 className="section-title">
            <span className="text-green">$</span> ls -la ./skills/
          </h2>
          
          <div className="skills-grid">
            <div className="skill-category">
              <div className="category-header">
                <Server size={24} className="category-icon" />
                <h3 className="category-title">drwxr-xr-x backend/</h3>
              </div>
              <ul className="skill-list">
                {skillCategories.backend.map((skill, index) => (
                  <li key={index} className="skill-item">
                    <span className="text-amber">▸</span> {skill}
                  </li>
                ))}
              </ul>
            </div>

            <div className="skill-category">
              <div className="category-header">
                <Shield size={24} className="category-icon" />
                <h3 className="category-title">drwxr-xr-x security/</h3>
              </div>
              <ul className="skill-list">
                {skillCategories.security.map((skill, index) => (
                  <li key={index} className="skill-item">
                    <span className="text-amber">▸</span> {skill}
                  </li>
                ))}
              </ul>
            </div>

            <div className="skill-category">
              <div className="category-header">
                <TerminalIcon size={24} className="category-icon" />
                <h3 className="category-title">drwxr-xr-x devops/</h3>
              </div>
              <ul className="skill-list">
                {skillCategories.devops.map((skill, index) => (
                  <li key={index} className="skill-item">
                    <span className="text-amber">▸</span> {skill}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        <div className="experience-section">
          <h2 className="section-title">
            <span className="text-green">$</span> cat experience.log
          </h2>
          
          <div className="experience-content">
            <div className="log-entry">
              <span className="log-timestamp text-cyan">[2020-PRESENT]</span>
              <span className="log-level text-green">INFO</span>
              <span className="log-message">
                Independent Backend Developer & Security Consultant
                <br />
                <span className="text-muted">
                  └─ Designing and implementing secure API architectures
                  <br />
                  └─ Conducting web application vulnerability assessments
                  <br />
                  └─ Building containerized microservices with Docker/Kubernetes
                </span>
              </span>
            </div>

            <div className="log-entry">
              <span className="log-timestamp text-cyan">[2018-2020]</span>
              <span className="log-level text-green">INFO</span>
              <span className="log-message">
                Backend Developer at Tech Company
                <br />
                <span className="text-muted">
                  └─ Developed RESTful APIs serving 1M+ daily requests
                  <br />
                  └─ Implemented security hardening measures
                  <br />
                  └─ Mentored junior developers on security best practices
                </span>
              </span>
            </div>
          </div>
        </div>

        <div className="certifications-section">
          <h2 className="section-title">
            <span className="text-green">$</span> ls certifications/
          </h2>
          <div className="cert-list">
            <div className="cert-item">
              <span className="text-purple">●</span> Degree in Computer Engineering
            </div>
            <div className="cert-item">
              <span className="text-purple">●</span> Maldev Academy Certification
            </div>
          </div>
        </div>
      </div>

      <div className="terminal-hint-bottom">
        <span className="text-muted">
          # Use terminal: type 'cat skills' or 'whoami' for more info
        </span>
      </div>
    </div>
  );
};

export default About;